import React from "react";
import { Chip, IconButton, makeStyles, TableBody } from "@material-ui/core";
import styles from "../../../styles/global-styles";
import StyleTableRow from "../../../styles/styleTableRow";
import StyledTableCell from "../../../styles/tableCell";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import NumberFormat from "react-number-format";

const useStyles = makeStyles((theme) => ({
  chip: styles.chip,
  backgroundIcon: styles.backgroundIcon,
  redBackgroundIcon: styles.redBackgroundIcon,
  deleteLink: styles.deleteLinkWithoutFontS,
  detailsLink: styles.detailsLink,
  body: styles.body,
}));

const DistributionListByCodeBar = ({
  productsForDistribution,
  modifiedDistribution,
  deleteProductFromList,
  updateAccesoryPrice,
}) => {
  const classes = useStyles();

  const updateProductPrice = (barCode, quantityForDistribution) => {
    updateAccesoryPrice(barCode, quantityForDistribution);
  };

  const modifiedQuantityForDistribution = (barCode, operation) => {
    modifiedDistribution(barCode, operation);
  };

  const deleteProductFrom = (barCode) => {
    deleteProductFromList(barCode);
  };

  const showProductPrice = (priceValue) => {
    return (
      <>
        {typeof priceValue === "string" ? (
          <strong style={{ fontSize: 14 }}>{priceValue}</strong>
        ) : (
          <NumberFormat
            value={priceValue}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        )}
      </>
    );
  };
  return (
    <TableBody>
      {productsForDistribution.map((product, i) => (
        <StyleTableRow key={i} className={classes.row}>
          <StyledTableCell align="center">{product.brand}</StyledTableCell>
          <StyledTableCell align="center">{product.model}</StyledTableCell>
          <StyledTableCell align="center">
            {product.subcategory}
          </StyledTableCell>
          <StyledTableCell align="center">{product.barCode}</StyledTableCell>
          <StyledTableCell align="center">
            {showProductPrice(product.price)}
          </StyledTableCell>
          <StyledTableCell align="center">
            <Chip label={product.availability} className={classes.chip} />
          </StyledTableCell>
          <StyledTableCell style={{ fontWeight: 800 }} align="center">
            {product.distribution || ""}
          </StyledTableCell>
          <StyledTableCell
            onClick={() =>
              modifiedQuantityForDistribution(product.barCode, "add")
            }
          >
            <IconButton color="primary" aria-label="add an alarm">
              <AddIcon className={classes.backgroundIcon} />
            </IconButton>
          </StyledTableCell>
          <StyledTableCell
            onClick={() =>
              modifiedQuantityForDistribution(product.barCode, "minus")
            }
          >
            <IconButton aria-label="error-icon">
              <RemoveIcon className={classes.redBackgroundIcon} />
            </IconButton>
          </StyledTableCell>
          <StyledTableCell
            className={classes.deleteLink}
            onClick={() => deleteProductFrom(product.barCode)}
          >
            Quitar accesorio
          </StyledTableCell>
          <StyledTableCell
            className={classes.detailsLink}
            onClick={() =>
              updateProductPrice(product.barCode, product.distribution)
            }
          >
            Modificar precio
          </StyledTableCell>
        </StyleTableRow>
      ))}
    </TableBody>
  );
};

export default DistributionListByCodeBar;
